<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">系统设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>交易对设置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <create-trade-pair
          @refresh="refreshList"
        ></create-trade-pair>
        <el-input placeholder="请输入交易对" clearable v-model="pair">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
        <pair-batch @refresh="refreshList"></pair-batch>
      </div>
      <el-tabs v-model="area" @tab-click="handleAreaChange" type="card">
        <el-tab-pane
          v-for="item in tradeArea"
          :label="item"
          :name="item"
          :key="item"
        ></el-tab-pane>
      </el-tabs>
      <trade-pair-list @refresh="refreshList"></trade-pair-list>
    </el-card>
    <trade-pair-detail
      @refresh="refreshList"
    ></trade-pair-detail>
  </div>
</template>

<script>
import './store';
import TradePairList from './components/list';
import CreateTradePair from './components/create';
import TradePairDetail from './components/detail';
import PairBatch from './components/batch';
import { mapActions, mapState } from 'vuex';
import { PAGINATION } from './constants';

export default {
  name: 'TradePairSetting',
  components: {
    TradePairList,
    CreateTradePair,
    TradePairDetail,
    PairBatch
  },
  data() {
    return {
      pair: null,
      area: '',
      queryCondition:{page:1,size: 999},
    };
  },
  computed: {
    ...mapState('tradeRange',['tradeRangeList']),
    ...mapState('tradePairSetting', ['pagination', 'tradeArea', 'plateList'])
  },
  methods: {
    ...mapActions('tradeRange',['findTradeRangeList']),
    ...mapActions('tradePairSetting', [
      'list',
      'listAllCoin',
      'getTradeArea',
      'getPlateList'
    ]),
    refreshList(data = {}) {
      this.list({
        pair: this.pair,
        area: this.area,
        ...this.pagination,
        ...data
      });
    },
    handleSearch() {
      this.list({
        pair: this.pair,
        area: this.area,
        ...this.pagination,
        page: 1
      });
    },
    handleAreaChange(tab) {
      this.pair = null;
      this.area = tab.name;
      this.list({
        pair: this.pair,
        area: this.area,
        ...this.pagination,
        page: 1
      });
    },
    // 获取区域等级列表
    queryTradeRangeList(){  
      this.queryCondition.page = 1;
      this.findTradeRangeList(this.queryCondition);
    },
  },
  created() {
    this.pair = null;
    this.listAllCoin();
    this.getTradeArea().then(() => {
      this.area = this.tradeArea[0];
      this.list({
        area: this.area,
        ...PAGINATION
      });
    });
    this.queryTradeRangeList()
    //this.queryVirtualTradeSet();
  }
};
</script>

<style lang="less" scoped></style>
